import { styled } from '@mui/material/styles'

export const PageWrapper = styled('div')`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;

  // В макете настроек таблица лежит в рамке, в отличие от парка и курьеров
  & .common-table {
    border: 1px solid #CFD6DD;
  }
`

export const SettingsHeader = styled('header')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 24px 24px;
  width: 100%;
  background: #fff;
  flex-shrink: 0;

  // На телефоне название «Настройки» и кнопка действия - в верхней панели
  // (layout/mobile-bars.js); эта шапка остаётся только слотом для портала
  @media (max-width: 899px) {
    display: none;
  }
`

export const SettingsTitle = styled('div')`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #272E35;
`

export const TabsBody = styled('div')`
  background: #F5F7F9;
  width: 100%;
  padding: 0 24px;
  flex-shrink: 0;
  overflow-x: auto;
  scrollbar-width: none;

  // Вкладок девять, и в узком окне они переносились на вторую строку:
  // держим одну строку и прокручиваем
  & > .MuiGrid-container {
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  @media (max-width: 899px) {
    padding: 0 16px;
  }
`

export const TabButton = styled('div')`
  font-weight: 500;
  cursor: pointer;
  font-size: 14px;
  color: ${(props) => (props.isActive ? '#2563EB' : '#555F6D')};
  padding: 12px 8px;
  border-bottom: 2px solid ${(props) => (props.isActive ? '#2563EB' : 'transparent')};

  &:hover {
    color: #2563EB;
  }
`